import { useMemo } from 'react';

import type { Station } from '../types/station';

/**
 * Filters the given stations against the provided query, matching against
 * both the station name and its city. Returns an empty array while the
 * query is blank or has no matches.
 */
export const useStationSearch = (stations: Station[], query: string): Station[] => {
  const results = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    if (!normalizedQuery) {
      return [];
    }

    return stations.filter(station => {
      const name = station.name.toLowerCase();
      const city = station.city.toLowerCase();

      return name.includes(normalizedQuery) || city.includes(normalizedQuery);
    });
  }, [stations, query]);

  return results;
};